import React from 'react';
import { BloodGlucoseChart } from 'components/ProgressTab/BloodGlucoseChart';
import { BloodGlucoseLegend, LegendFilter } from 'components/ProgressTab/BloodGlucoseLegend';
import { BloodGlucoseWeekSeries, mealsWithData } from 'features/progress/utils/bloodGlucoseMeals';

export type DetailChartFilter = LegendFilter;

export interface BloodSugarDetailChartProps {
  series: BloodGlucoseWeekSeries;
  filter: DetailChartFilter;
  onFilterChange: (filter: DetailChartFilter) => void;
  yRange: { min: number; max: number };
}

export const BloodSugarDetailChart = ({
  series,
  filter,
  onFilterChange,
  yRange,
}: BloodSugarDetailChartProps) => {
  // Only meals with at least one reading this window are plotted/filterable -- a member's care
  // program tracks a handful of these 7, not all at once (confirmed with product), and this is
  // the same set the compact widget shows for the same data.
  const meals = mealsWithData(series);

  return (
    <BloodGlucoseChart
      series={series}
      meals={filter === 'all' ? meals : [filter]}
      yRange={yRange}
      legend={<BloodGlucoseLegend meals={meals} filter={filter} onFilterChange={onFilterChange} />}
    />
  );
};
